import { render, staticRenderFns } from "./editOutsidePrice.vue?vue&type=template&id=8f72ec38&scoped=true"
import script from "./editOutsidePrice.vue?vue&type=script&lang=js"
export * from "./editOutsidePrice.vue?vue&type=script&lang=js"
import style0 from "./editOutsidePrice.vue?vue&type=style&index=0&id=8f72ec38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f72ec38",
  null
  
)

export default component.exports